import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ENUMS from '../../../../enums';
import { formatter, enumHelper, domManipulator } from '../../../../utils';
import * as cafeDiscountActions from '../../../../redux/cafeDiscounts/actions';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Spin from '../../../../components/loading';
import styles from '../../styles.scss';
import AlertAndConfirmation from '../../../../utils/AlertAndConfirmation';

const CafeDiscountRequestDetails = props => {
  let {
    cafeDiscountRequestDetails,
    cafeDiscountRequestDetailsLoading,
    cafeDiscountRequestDetailsError,
    cafeDiscountRequestDetailsFailed,
    cafeDiscountRequestDetailsMessage,

    updateCafeDiscountRequestStatusLoading,
    updateCafeDiscountRequestStatusFailed,
    updateCafeDiscountRequestStatusError,
    updateCafeDiscountRequestStatusMessage,
  } = props;
  let {
    cafeName,
    id,
    fromDate,
    toDate,
    cafeDiscountItems,
    currency,
    rejectionReason,
    respondedAt,
    respondedFullName,
    createdFullName,
    status,
    createdAt,
    cafeId,
  } = cafeDiscountRequestDetails;

  let [reason, setReason] = useState('');
  let [alert, setAlert] = useState(false);
  let [alertColor, setAlertColor] = useState('success');
  let [alertText, setAlertText] = useState('');

  const discountDays =
    cafeDiscountItems && cafeDiscountItems.length
      ? [...new Set(cafeDiscountItems.map(item => item.weekday))]
      : [];

  const changeDiscountStatus = status => {
    if (status == 'reject' && !reason) {
      domManipulator.scrollToTop();
      setAlert(true);
      setAlertText('titles.rejectReasonIsRequired');
      setAlertColor('danger');
    } else {
      props
        .updateCafeDiscountRequestStatus(
          props.cafeDiscountRequestId,
          status,
          reason,
        )
        .then(async () => {
          const {
            updateCafeDiscountRequestStatusFailed,
            updateCafeDiscountRequestStatusError,
            updateCafeDiscountRequestStatusMessage,
          } = props;
          if (
            updateCafeDiscountRequestStatusFailed == false &&
            updateCafeDiscountRequestStatusMessage == null &&
            updateCafeDiscountRequestStatusError == false
          ) {
            AlertAndConfirmation({
              title: locales('titles.editionsDoneSuccessfully'),
              text: '',
              type: 'success',
            });
            setAlert(true);
            setAlertColor('success');
            setAlertText('titles.redirectedToCafeDiscountRequestArchives');
            const query = props.buildSearchQuery(props.pageNumber, props.pageSize);
            await props.fetchAllCafeDiscountRequests(query);
            props.closeModal();
          } else {
            domManipulator.scrollToTop();
          }
        });
    }
  };

  useEffect(() => {
    props.fetchCafeDiscountRequestDetailsById(props.cafeDiscountRequestId);
  }, []);
  return (
    <>
      <Modal id='financial-transaction-modal' size='xl' isOpen={props.isOpen}>
        <ModalHeader>
          <div className='row'>
            <div className='col-11'>
              {locales('titles.cafeDiscountRequestDetails')}
            </div>
            <div className='col-1 text-left'>
              <a
                href='#'
                className=''
                onClick={event => {
                  event.preventDefault();
                  props.closeModal();
                }}
              >
                <i className='fas fa-times'></i>
              </a>
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          {/* <div className='col-12 d-flex justify-content-center align-items-center h-100'>  */}
          <Spin
            spinning={
              cafeDiscountRequestDetailsLoading ||
              updateCafeDiscountRequestStatusLoading
            }
          >
            <article>
              {cafeDiscountRequestDetailsError ||
              updateCafeDiscountRequestStatusError ? (
                <div className='alert alert-danger'>
                  {locales('messages.server.error')}
                </div>
              ) : (
                <>
                  {(cafeDiscountRequestDetailsFailed ||
                    updateCafeDiscountRequestStatusFailed) && (
                    <div className='alert alert-danger'>
                      {cafeDiscountRequestDetailsMessage ||
                      updateCafeDiscountRequestStatusMessage}
                    </div>
                  )}
                  <article className='col-12'>
                    {alert && (
                      <div className={`alert alert-${alertColor}`}>
                        {locales(alertText)}
                      </div>
                    )}
                    <div className='d-flex my-3'>
                      <div className='col-4'>
                        <span className='text-muted rsee-form-label'>
                          {locales('fields.cafe.name')}
                        </span>
                        <span className='text-dark font-weight-bold font-large mx-1'>
                          {cafeName || '---'}
                        </span>
                      </div>

                      <div className='col-4'>
                        <span className='text-muted rsee-form-label'>
                          {locales('fields.createdAt')}
                        </span>
                        <span className='text-dark font-weight-bold font-large mx-1'>
                          {createdAt || '---'}
                        </span>
                      </div>

                      <div className='col-4'>
                        <span className='text-muted rsee-form-label'>
                          {locales('tables.status')}
                        </span>
                        <span className='text-dark font-weight-bold font-large'>
                          {enumHelper.convertEnumValueToTitle(
                            ENUMS.CAFE_DISCOUNT_STATUS.list,
                            status,
                          )}
                        </span>
                      </div>
                    </div>

                    <div className='d-flex my-3'>
                      <div className='col-4'>
                        <span className='text-muted rsee-form-label'>
                          {locales('titles.creatorName')}
                        </span>
                        <span className='text-dark font-weight-bold font-large mx-1'>
                          {createdFullName || '---'}
                        </span>
                      </div>

                      <div className='col-4'>
                        <span className='text-muted rsee-form-label'>
                          {locales('tables.respondedFullName')}
                        </span>
                        <span className='text-dark font-weight-bold font-large mx-1'>
                          {respondedFullName || '---'}
                        </span>
                      </div>

                      <div className='col-4'>
                        <span className='text-muted rsee-form-label'>
                          {locales('tables.respondedAt')}
                        </span>
                        {respondedAt || '---'}
                      </div>
                    </div>

                    <div className='d-flex my-3'>
                      <div className='col-4'>
                        <span className='text-muted rsee-form-label'>
                          {locales('labels.from.date')}
                        </span>
                        <span className='text-dark font-weight-bold font-large mx-1'>
                          {fromDate || '---'}
                        </span>
                      </div>

                      <div className='col-4'>
                        <span className='text-muted rsee-form-label'>
                          {locales('labels.to.date')}
                        </span>
                        <span className='text-dark font-weight-bold font-large mx-1'>
                          {toDate || '---'}
                        </span>
                      </div>
                    </div>

                    <div className='d-flex my-3 flex-wrap'>
                      <div className='col-12'>
                        <span className='text-muted rsee-form-label'>
                          {locales('labels.rejectionReason')}
                        </span>
                        <span className='text-dark font-weight-bold'>
                          {rejectionReason || '---'}
                        </span>
                      </div>
                    </div>

                    <table
                      className={`table table-striped table-hover table-light table-bordered my-3 ${styles['table-row-overflow']}`}
                    >
                      <thead>
                      <tr>
                        <th className='text-center'>
                          {locales('fields.week.day')}
                        </th>
                        <th className='text-center'>
                          {locales('fields.discounts')}
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      {discountDays.map(discount => (
                        <tr key={discount}>
                          <td className='text-center'>
                            {enumHelper.convertEnumValueToTitle(
                              ENUMS.WEEK_DAYS.list,
                              discount,
                            )}
                          </td>
                          <td className='text-center'>
                            <div className='d-flex justify-content-center'>
                              {[
                                ...cafeDiscountItems.filter(
                                  item => item.weekday == discount,
                                ),
                              ].map(item => (
                                <React.Fragment key={item.id}>
                                  <div className='px-3'>
                                    <div className='px-3'>{`${item.toTime}-${item.fromTime}`}</div>
                                    <div className='px-3 flex-column'>
                                      {`${formatter.numberWithCommas(
                                        item.discountValue,
                                      )} ${
                                        item.discountType ===
                                        ENUMS.CAFE_DISCOUNT_VALUE_TYPES.values
                                          .PERCENT
                                          ? enumHelper.convertEnumValueToTitle(
                                          ENUMS.CAFE_DISCOUNT_VALUE_TYPES
                                            .list,
                                          item.discountType,
                                          )
                                          : enumHelper.convertEnumValueToTitle(
                                          ENUMS.MONEY_UNITS.list,
                                          currency,
                                          )
                                      }`}
                                    </div>
                                  </div>
                                </React.Fragment>
                              ))}
                            </div>
                          </td>
                        </tr>
                      ))}
                      </tbody>
                    </table>

                    {props.isFromArchive && (
                      <textarea
                        value={reason}
                        placeholder={locales('labels.rejectionReason')}
                        className='form-control p-2'
                        onChange={event => setReason(event.target.value)}
                      />
                    )}
                  </article>
                </>
              )}
            </article>
          </Spin>
        </ModalBody>
        <ModalFooter>
          {props.isFromArchive && (
            <div className='mx-4 col-10 d-flex justify-content-end'>
              <button
                className='btn btn-danger w-20 mx-1'
                onClick={() => changeDiscountStatus('reject')}
              >
                {locales('titles.rejectComment')}
              </button>
              <button
                className='btn btn-success w-20 mx-1'
                onClick={() => changeDiscountStatus('approve')}
              >
                {locales('tables.approve')}
              </button>
            </div>
          )}
          <button className='btn btn-light' onClick={() => props.closeModal()}>
            {locales('labels.close.modal')}
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};
const mapStateToProps = state => {
  return {
    cafeDiscountRequestDetails:
      state.cafeDiscountsReducer.cafeDiscountRequestDetailsById || {},
    cafeDiscountRequestDetailsLoading:
    state.cafeDiscountsReducer.cafeDiscountRequestDetailsByIdLoading,
    cafeDiscountRequestDetailsMessage:
    state.cafeDiscountsReducer.cafeDiscountRequestDetailsByIdMessage,
    cafeDiscountRequestDetailsFailed:
    state.cafeDiscountsReducer.cafeDiscountRequestDetailsByIdFailed,
    cafeDiscountRequestDetailsError:
    state.cafeDiscountsReducer.cafeDiscountRequestDetailsByIdError,

    updateCafeDiscountRequestStatusLoading:
    state.cafeDiscountsReducer.updateCafeDiscountRequestStatusLoading,
    updateCafeDiscountRequestStatusMessage:
    state.cafeDiscountsReducer.updateCafeDiscountRequestStatusMessage,
    updateCafeDiscountRequestStatusFailed:
    state.cafeDiscountsReducer.updateCafeDiscountRequestStatusFailed,
    updateCafeDiscountRequestStatusError:
    state.cafeDiscountsReducer.updateCafeDiscountRequestStatusError,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchAllCafeDiscountRequests: query =>
      dispatch(cafeDiscountActions.fetchAllCafeDiscountRequests(query)),
    fetchCafeDiscountRequestDetailsById: id =>
      dispatch(cafeDiscountActions.fetchCafeDiscountRequestDetailsById(id)),
    updateCafeDiscountRequestStatus: (id, status, reason) =>
      dispatch(
        cafeDiscountActions.updateCafeDiscountRequestStatus(id, status, reason),
      ),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CafeDiscountRequestDetails);
